<script setup lang="ts">
// ⚠️ Could not locate NuxtLink.vue
const router = useRouter()
const route = useRoute()
const emit = defineEmits<{ (e: 'selected'): void }>()

const props = withDefaults(defineProps<{
	category: {
    name: string,
    description: string,
    shortDescription: string,
    image: string,
    slug: string,
  }
}>(), {
	category: () => {
    return {
      name: 'Kitchen Products',
      description: 'Powerful detergents, degreasers and sanitisers that keep every kitchen surface spotless, compliant and safe for food preparation.',
      shortDescription: 'Powerful detergents, degreasers and sanitisers that keep every kitchen surface spotless, compliant and safe for food preparation.',
      image: '/images/kitchen-2.jpg',
      slug: 'kitchen',
    }
  }
})


function redirect(path: string) {
	emit('selected')
	router.push(`/products/${path}`);
}
</script>

<template>
	<Frame @click="redirect(category.slug)" class="sec-product-category-card flex min-h-230px gp-1" w="w-full grid grid-cols-[auto_1fr] g-1.25 gpx-1 gpy-0.5" :class="{'active': route.path === `/products/${category.slug}`}">
		<div class="card-image flex items-center justify-center">
			<div class="card-image-inner">
				<img class="transition-all duration-500" :src="category.image" :alt="category.name" />
			</div>
		</div>
		<Frame class="card-content flex-1" w="flex flex-col justify-center g-0 max-w-80% ds:max-w-100% mx-auto">
			<div class="title fs-1.5! glh-1.2! gmb-0.5">
				{{ category.name }}
			</div>
			<div class="description glh-1.2! fs--05!">{{ category.shortDescription }}</div>
			<div class="card-action">

				<a class="card-link">
					<!-- <span class="icon icon-arrow"></span> -->
					<span class="label">Learn more</span>
          <i class="i-mdi:arrow-right text-base flex" />
				</a>
			</div>
		</Frame>
	</Frame>
</template>

<style lang="scss" scoped>
.sec-product-category-card {
	display: flex;
	overflow: hidden;
	transition: all 300ms ease-in-out, transform 0s ease-in-out;
	background: white;
	border: 0;
	border-radius: 0.75rem;
	width: 100%;
	cursor: pointer;
  padding: 0;
  border: 1px solid transparent;


	.card-image {
		/* @apply flex-none w-2/5 h-full overflow-hidden; */
		transition: transform 0.5s ease-in-out;
		position: relative;
		/* background: red; */
		width: 100px;
		flex: 1;

		display: flex;
		align-items: flex-start;
		justify-content: center;

		.card-image-inner {
			width: 100%;
			position: relative;
			overflow: hidden;
			border-radius: 100%;
			aspect-ratio: 1/1;
			margin-top: gr(1);

			img {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				object-fit: cover;
			}
		}

	}

	/* .card-image img { */
	/*     @apply w-full h-full object-cover; */
	/*     transition: transform 0.5s ease-in-out; */
	/*     position: absolute; */
	/* } */

	.card-content {

		position: relative;
		display: grid;
		transition: all 0.3s ease-in-out;


		.title {
			font-weight: 400;
			font-size: fs(1);
			font-family: var(--quicksand);
			line-height: gr(1.1);
      color: var(--heading-primary);
		}

		.description {
			color: var(--body-primary);
      font-size: fs(0);
      margin-bottom: gr(0.5)
		}

		.card-action {

			transition: all 0.5s;

			position: relative;
			bottom: 0;
			left: 0;

			transform: translateY(0);
			opacity: 1;

			a {
        text-transform: uppercase;
        display:flex;
        align-items: center;
        position: relative;
        transition: all 0.2s ease-in-out;
				span {
					font-size: fs(-1);
          letter-spacing: 0.03em;
					color: var(--base-650);
				}
        i {
          margin-left: gr(0.5);
          font-size: fs(-15);
          transform: translateX(-100%);
          transition: all 0.2s ease-in-out;

          opacity: 0;
          color: var(--base-650);
        }

        
			}
		}

		@include mq($from: t) {
			// padding: gr(1.25) gr(1.5) gr(1.25) gr(0);
		}
	}

	.card-title {
		font-size: fs(1);
		font-weight: 400;
		margin: 0 0 gr(1) 0;
		line-height: gr(1.25);


		@apply tracking-wide;

		color: var(--heading-primary);
		line-height: gr(1.1);
	}

	.card-description {
		color: var(--base-600);
		margin-bottom: 0;
	}




	.icon-arrow {
		@apply w-4 h-4 bg-black inline-block;
		-webkit-mask: url('/path/to/arrow-icon.svg') no-repeat center;
		mask: url('/path/to/arrow-icon.svg') no-repeat center;
		-webkit-mask-size: cover;
		mask-size: cover;
	}

	/* Hover effect for image zoom out */
	.card:hover .card-image img {
		transform: scale(1.1);
	}

	@include mq($until: 600px) {
		@apply flex-col h-auto;

		.card-image {
			@apply w-full h-48;
		}

		.card-content {
			@apply w-full;

		}
	}

	&:hover, &.active {

    border: 1px solid var(--blue-100);

		.card-image {
			img {
				transform: scale(1.05)
			}
		}

		.card-content {

      .title {
        color: var(--cyan-500);
      }

      .card-action {
        a {
          // padding-left: gr(0.25);
          span {
            color: var(--blue-700);
          }

          i {
            opacity: 1;
            transform: translateX(-25%) translateY(-1px);
          }


          &:hover {
            
            &:active {
              i {
                transform: translateX(-0%) translateY(0px);
              }
            }
          }
        }
      }

		}

		&:active {
			transform: translateY(1px);
		}
	}
}
</style>
